import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { GalleryThemeService } from '../../../services/gallery-theme.service';
import { GalleryService } from '../../../services/gallery.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { CoverDesignComponent } from '../cover-design/cover-design.component';

@Component({
  selector: 'app-theme-cover-select-item',
  imports: [CoverDesignComponent, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-cover-select-item.component.html',
  styleUrl: './theme-cover-select-item.component.scss',
})
export class ThemeCoverSelectItemComponent {
  galleryService = inject(GalleryService);
  galleryThemeService = inject(GalleryThemeService);
  gallery = input.required<GalleryDto>();
  onChanged = output<string | null>();
  theme = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });
  coverDesigns = ['simple', 'frame', 'faded', 'stripes'];

  previewThemes = computed(() => {
    const theme = this.theme();
    if (!theme) return;
    return this.coverDesigns.map(design => ({
      ...theme,
      cover: {
        ...theme.cover,
        design,
        title_typography: { ...theme.cover.title_typography, font_color: 'rgba(255,255,255,1)' },
      },
    }));
  });

  selectDesign(design: string) {
    this.galleryService.updateGallery(this.gallery(), {
      theme: this.galleryThemeService.getCoverDesignChangeParams(this.theme(), design),
    });
    this.onChanged.emit(design);
  }
}
